// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ViewUI from "view-design";
import "babel-polyfill";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
/*import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'*/
import { isEmpty } from "@/utils";
import Cookies from 'js-cookie';
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);
import { Message } from "element-ui";
import scroll from 'vue-seamless-scroll'
import { behaviorpageAccess} from '@/api/apiPot.js'
import tracking from '@/utils/tracking/index'
Vue.use(scroll)

// import style
import "view-design/dist/styles/iview.css";
//引入全局css
import "./assets/css/common.css";
import store from "@/vuex/store";
import "@/styles/index.less"; // 全局样式

//引入axios请求数据
import axios from "axios";
import http from "./utils/http";
import https from "./utils/http";
import Qs from "qs";
// main.js
import noLogin from "./components/popup";
// 全局未登录
Vue.prototype.$noLogin = noLogin.install;

/*import http from '@/request'; // 引入接口列表*/

Vue.use(ViewUI);

Vue.prototype.axios = axios;
Vue.prototype.$http = http;
Vue.prototype.$https = https;
Vue.prototype.qs = Qs;
/*Vue.prototype.$http = http; // 将接口列表挂载到全局*/
var startTime ='';
var endData = '';
Vue.config.productionTip = false;

// 初始化 Tracking SDK（不自动注册路由守卫，由下方手动集成）
tracking.init(router, { autoGuard: false })

// 存储路由守卫中的 from 路由对象，用于 afterEach 中传给 tracking SDK 采集来源页
var _trackingFromRoute = null

router.beforeEach((to, from, next) => {
  /*
    开始时间是开始记录
    结束 - 只用来发请求 -》 清空
  */

  if (startTime) {
    endData = new Date().getTime()
    var count = endData - startTime

    if(count < 0){
      count = 1000
    }else if(count > 3600000){
      count = 3600000
    }
    behaviorpageAccess({ page_index: to.meta.nameCN || '首页',superior_index:from.meta.nameCN || '' ,residence_time :count})
    // 发请求 -》 -
  }
  startTime = new Date().getTime()

  // Tracking SDK：离开当前页面，并记录来源路由（from）供 afterEach 使用
  _trackingFromRoute = from
  tracking.leave()

  if(to.path === "/GoodsDetailPreview"){
    // 如果不需要权限校验，直接进入路由界面
    ViewUI.LoadingBar.start();
    next();
  }else {
    if (!to.meta.isAllowNoLogin) {
      // 判断该路由是否需要登录权限

      if (isEmpty(Cookies.get("userName"))) {
        // 获取当前的token是否存在
        noLogin.install();
        next(false);
      } else {
        if (!isEmpty(Cookies.get("userInfo"))) {
          // 拦截/NewSpecialOffer）和新人优惠券（NewCoupons）页面
          if (
            (to.path === "/NewSpecialOffer" || to.path === "/NewCoupons") &&
            (sessionStorage.getItem('new_customer') != 1)
          )
            {
              Message.error("你不是新用户，暂不可享受新人福利");
              next(false);
            }
          else {
                    // 获取来源页面和去往的页面
                    ViewUI.LoadingBar.start();
                    next();
            // 创建一个时间戳，用于记录页面访问时长


            // 在路由元信息（meta）中存储这些信息，以便后续使用
            // to.meta.startTime = startTime;


          }
        } else {
          noLogin.install();
          next(false);
        }
      }
    } else {
      // 如果不需要权限校验，直接进入路由界面
      ViewUI.LoadingBar.start();
      next();
    }
  }

});

router.afterEach(to => {
  ViewUI.LoadingBar.finish();
  // Tracking SDK：进入新页面，同时传入 from 路由对象用于来源页采集
  tracking.enter(to, _trackingFromRoute);
  _trackingFromRoute = null;
});

/* eslint-disable no-new */
window.vm = new Vue({
  el: "#app",
  store,
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js